import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Subscription Ads
 */
export default class SubscriptionAdsListValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<SubscriptionAdEntity>} deps.items
   * @param {Number} deps.totalPages
   * @param {Number} deps.totalResults
   */

  getItems = () => this._items
}
